import { useState, useEffect } from "react";
// import { useGetAllAccountsQuery } from "src/services/AccountServices";
import { useGetUserAccessQuery } from "src/services/useraccess/UserAccessServices";
import useLocalStorageData from "./useLocalStorageData";
import { ModulesTypes, setUserModule } from "src/redux/slices/access/userAcessSlice";
import { useDispatch } from "react-redux";
import { setUserType } from "src/redux/slices/AuthSlice";

const useAccessModule = () => {
    const { userData } = useLocalStorageData()
    const dispatch = useDispatch()
    const [userAccessModules, setuserAccessModules] = useState([])
    const [userTypeForAccess, setUserTypeForAccess] = useState("ADMIN")

    const { data: userAccessData, isLoading: userAccessIsloading, isFetching: userAccessIsFilter } = useGetUserAccessQuery(
        {
            userId: userData?.userId,
            userRoleName: userData?.userRole,
        },
        {
            skip: !userData?.userRole,
        }
    );
    useEffect(() => {
        if (!userAccessIsloading && !userAccessIsFilter ) {
            if(!userAccessData?.data)
            {
                dispatch(setUserType("ADMIN"));
                return
            }
          
            setuserAccessModules(userAccessData.data.module || [])
            dispatch(setUserModule([...userAccessData.data.module]))
            setUserTypeForAccess(userAccessData.data.userRoleName)
            dispatch(setUserType(userAccessData.data.userType));
            localStorage.setItem("userType",userAccessData.data.userType)
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAccessData, userAccessIsloading, userAccessIsFilter])

    const isModuleAuthorize = (moduleName: string) => {

        const isExist = userAccessModules?.find((module: ModulesTypes) =>
            moduleName === module.moduleName || module.childGroup.includes(moduleName)
        )

        if (isExist) {
            return true
        }
        if (userTypeForAccess === "ADMIN" )
            return true
        return false
    }

    return { isModuleAuthorize, userAccessData,userAccessIsloading };
};

export default useAccessModule;
